<template>
  <vx-card
    class="user-account-opening-hours"
    no-shadow
  >
    <div class="flex justify-center">
      <form
        class="w-full md:w-1/2 xl:w-1/4"
        @submit.prevent>

        <h3 class="mb-5">
          {{ $t('$UserSettings.$Account.$OpeningHours.TabTitle') }}
        </h3>

        <div
          v-for="(dayOfWeek, dayIndex) in model"
          :key="dayIndex"
          class="vx-row">
          <div class="vx-col w-full flex justify-between items-center">
            <label>{{ $t(`$DaysOfWeek.${dayOfWeek.day}`) }}</label>
            <vs-switch v-model="dayOfWeek.open"/>
          </div>

          <template v-if="dayOfWeek.open">
            <div
              v-for="(slot, slotIndex) in dayOfWeek.slots"
              :key="slotIndex"
              class="vx-col flex items-center w-full md:w-2/3 mt-3">
              <vs-input
                v-model="slot.openingTime"
                type="time"
              />
              <span class="px-1 md:px-3">-</span>
              <vs-input
                v-model="slot.closingTime"
                type="time"
              />

              <feather-icon
                v-if="dayOfWeek.slots.length === 2"
                svgClasses="h-4 w-4 ml-1 md:ml-3 cursor-pointer"
                icon="XIcon"
                @click="removeSlot(dayIndex, slotIndex)"/>
            </div>

            <div
              v-if="dayOfWeek.slots.length < 2"
              class="vx-col w-full">
              <a
                role="button"
                class="link-cta mt-3"
                @click.prevent="addSlot(dayIndex)">
                <feather-icon
                  svgClasses="h-4 w-4"
                  icon="PlusIcon"/>
                {{ $t('AddSetOfHours') }}
              </a>
            </div>
          </template>

          <div
            class="vx-col w-full"
            v-else>
            <small class="font-light">{{ $t('Closed') }}</small>
          </div>

          <vs-divider/>
        </div>

        <vs-button
          v-if="!asWizardStep"
          class="mt-base"
          @click="saveOpeningHours">
          {{ $t('$General.Save') }}
        </vs-button>
      </form>
    </div>
  </vx-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import { deepCopy } from '@/util';

export default {
  name: 'UserAccountOpeningHours',
  i18n: {
    messages: {
      en: {
        AddSetOfHours: 'Add a set of hours',
        Closed: 'Closed',
        UpdatedNtfTitle: 'Opening hours',
        UpdatedNtfText: 'Opening hours updated successfully.',
      },
    },
  },
  components: {},
  props: {
    asWizardStep: {
      type: Boolean,
      require: false,
      default: false,
    },
  },
  data() {
    return {
      model: [
        {
          day: this.$enums.DAYS_OF_WEEK.MONDAY,
          open: false,
          slots: [
            { openingTime: '09:00', closingTime: '18:00' },
          ],
        },
        {
          day: this.$enums.DAYS_OF_WEEK.TUESDAY,
          open: false,
          slots: [
            { openingTime: '09:00', closingTime: '18:00' },
          ],
        },
        {
          day: this.$enums.DAYS_OF_WEEK.WEDNESDAY,
          open: false,
          slots: [
            { openingTime: '09:00', closingTime: '18:00' },
          ],
        },
        {
          day: this.$enums.DAYS_OF_WEEK.THURSDAY,
          open: false,
          slots: [
            { openingTime: '09:00', closingTime: '18:00' },
          ],
        },
        {
          day: this.$enums.DAYS_OF_WEEK.FRIDAY,
          open: false,
          slots: [
            { openingTime: '09:00', closingTime: '18:00' },
          ],
        },
        {
          day: this.$enums.DAYS_OF_WEEK.SATURDAY,
          open: false,
          slots: [
            { openingTime: '09:00', closingTime: '18:00' },
          ],
        },
        {
          day: this.$enums.DAYS_OF_WEEK.SUNDAY,
          open: false,
          slots: [
            { openingTime: '09:00', closingTime: '18:00' },
          ],
        },
      ],
    };
  },
  computed: {
    ...mapGetters({
      tenantAccountSettingsOpeningHours: 'auth/tenantAccountSettingsOpeningHours',
    }),
    formWasChanged() {
      return JSON.stringify(this.model) !== JSON.stringify(this.tenantAccountSettingsOpeningHours);
    },
  },
  created() {
    if (this.tenantAccountSettingsOpeningHours
      && Array.isArray(this.tenantAccountSettingsOpeningHours)
      && this.tenantAccountSettingsOpeningHours.length > 0) {
      this.model = deepCopy(this.tenantAccountSettingsOpeningHours);
    }
  },
  methods: {
    ...mapActions({
      updateTenantAccountOpeningHoursSettings: 'auth/updateTenantAccountOpeningHoursSettings',
    }),
    addSlot(dayIndex) {
      this.model[dayIndex].slots.push({ openingTime: '09:00', closingTime: '18:00' });
    },
    removeSlot(dayIndex, slotIndex) {
      console.log('removeSlot', dayIndex, slotIndex);
      this.model[dayIndex].slots.splice(slotIndex, 1);
    },
    async saveOpeningHours() {
      const formIsValid = await this.$validator.validateAll();

      if (formIsValid) {
        this.$vs.loading({ type: 'radius' });
        await this.updateTenantAccountOpeningHoursSettings(this.model);
        this.$vs.loading.close();

        this.$showSuccessActionNotification({
          title: this.$t('UpdatedNtfTitle'),
          text: this.$t('UpdatedNtfText'),
        });
      }
    },
  },
};
</script>

<style lang="scss">
.user-account-opening-hours {
  .vs-component.vs-switch {
    margin-top: 0 !important;
  }
}
</style>
